import cookie from "js-cookie"
import { logout } from "lib/api"
import type { LocaleType } from "lib/apollo/types"

export const bpStorePreference = "BP_STORE_PREFERENCE"

function toCountry(_locale: LocaleType) {
  return _locale === "en-GB" ? "UK" : "US"
}

const cookieWithoutEncoding = cookie.withConverter({
  write: (value) => value as any,
})

export const setStorePreference = (_locale: LocaleType): void => {
  cookie.set(bpStorePreference, toCountry(_locale))
  const d = new Date()
  const years = 10 * 365 * 24 * 60 * 60 * 1000 // 10 years
  d.setTime(d.getTime() + years)

  cookieWithoutEncoding.set("BP_STORE_PREFERENCE_TIMESTAMP", d.toString(), {
    expires: 3650,
  })
}

export const getStorePreference = (): string | undefined =>
  cookie.get(bpStorePreference)

export type HrefLangType = {
  hreflang: string
  href: string
}

const getHrefLangTags = (): HrefLangType[] => {
  return (
    [...document.querySelectorAll('link[rel="alternate"]')] as HTMLLinkElement[]
  ).map((link) => {
    return { hreflang: link.hreflang, href: link.href }
  })
}

export const getRedirectPathname = (
  hreflang: string,
  hreflangTags: HrefLangType[]
): string | undefined => {
  const tag = hreflangTags.find((t) => t.hreflang === hreflang)?.href

  const fullURL = tag && new URL(tag).pathname + (tag && new URL(tag)?.search)
  return fullURL
}

const storePath = {
  "en-GB": "/",
  "en-US": "/us",
}

// @todo: this is also shared by login so ought to be lifted out as a more generic helper
export const changeRegion = async (locale: LocaleType): Promise<void> => {
  await logout()
  setStorePreference(locale)

  const redirectUrl =
    window.location.origin +
    (getRedirectPathname(locale, getHrefLangTags()) || storePath[locale])

  window.location.replace(redirectUrl)
}
